export const CALL_TYPE_LABELS: Record<string, string> = {
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
  NON_PRIMARY: 'Non-Primary'
};

export const CALL_STATUS_LABELS: Record<string, string> = {
  MISSED_CALL: 'Missed Call',
  CONNECTED: 'Connected',
  NOT_CONNECTED: 'Not Connected',
  PROMISE_TO_PAY: 'Promise to Pay',
  SELF_CALL: 'Self Call',
  CALL_BRIDGE: 'Call Bridge',
  AMEYO: 'Ameyo',
  HUMAN_REMINDER: 'Human Reminder',
  WHATSAPP_CALL: 'Whatsapp Call',
  WHATSAPP_TEXT: 'Whatsapp Text',
  SKIP_TRACING_TELE: 'Skip Tracing Tele',
  INBOUND_CALL: 'Inbound Call',
  BOT_REMINDER: 'Bot Reminder',
  VENDOR_POC: 'Vendor POC'
};

export const TEAM_LABELS: Record<string, string> = {
  INHOUSE_TELE: 'In-house Tele',
  INHOUSE_FIELD: 'In-house Field',
  AGENCY_TELE: 'Agency Tele',
  AGENCY_FIELD: 'Agency Field',
  EXTERNAL_TELE: 'External Tele',
  EXTERNAL_FIELD: 'External Field',
  INHOUSE_CSA: 'In-house CSA',
  EXTERNAL_CSA_INHOUSE: 'External CSA (In-house)',
  EXTERNAL_CSA_AGENCY: 'External CSA (Agency)'
};
